export enum StoreType {
  Supermarket = "Supermarket",
  Hypermarket = "Hypermarket",
  Pharmacy = "Pharmacy",
}
